// removed by extract-text-webpack-plugin
module.exports = {"vpToggleButton":"vpToggleButton___2xGhv","vpOverlay":"vpOverlay___242ot","vpOverlayInner":"vpOverlayInner___1WChR","vpText":"vpText___gS-r8"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpTeleprompterOverlay/VpTeleprompterOverlay.module.less
// module id = 3520
// module chunks = 33